import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppCtxComponent } from 'js/reactAppCtx';
import AwGlobalPopup from 'viewmodel/AwGlobalPopupViewModel';
import SearchResultsTableViewModel from 'viewmodel/SearchResultsTableViewModel';

export default class DesSearchResultsAsTable extends HTMLElement {

    constructor() {
        super();
    }

    static get observedAttributes() {
        return ['accsessionid', 'acc-session-id', 'locale', 'collaborationspaceid', 'collaborationspace-id',
            'project-id', 'commands-url'];
    }

    connectedCallback() {
        this.classList.add('afx-content-background');
        this.createReactElement();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        ReactDOM.unmountComponentAtNode(this);
        this.createReactElement();
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get accsessionid() {
        return this.getAttribute('acc-session-id') || this.getAttribute('accsessionid');
    }

    get locale() {
        return this.getAttribute('locale');
    }

    createReactElement() {
        ReactDOM.render(
            <AppCtxComponent>
                <AwGlobalPopup />
                {React.createElement(
                    SearchResultsTableViewModel,
                    {
                        accsessionid: this.accsessionid,
                        locale: this.locale,
                        ...this.getProps()
                    },
                    React.createElement('slot')
                )}
            </AppCtxComponent>,
            this);
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            projectid: this.getAttribute('project-id'),
            commandsUrl: this.getAttribute('commands-url'),
            viewId: 'searchResultsTableView',
            viewPath: 'viewPath'
        };
    }

    disconnectedCallback() {
        ReactDOM.unmountComponentAtNode(this);
    }
}
if (!window.customElements.get('des-search-results-as-table')) {
    window.customElements.define(
        'des-search-results-as-table',
        DesSearchResultsAsTable
    );
}
